import { queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { useProjectId } from "@/hooks/Network/useProjectId";
import { QUERY_KEYS } from "@/query-keys";

export const usePermissionQueries = () => {
  const api = useApi();
  const projectId = useProjectId();

  return {
    listRoles: () =>
      queryOptions({
        queryKey: QUERY_KEYS.PERMISSION_ROLES(projectId),
        queryFn: () => api.getPermissionsRolesV1(),
        select: commonAPIDataSelector,
      }),
    listDefaultGroups: () =>
      queryOptions({
        queryKey: QUERY_KEYS.COMMUNITY_GROUPS_DEFAULT_PERMISSIONS(projectId),
        queryFn: () => api.getPermissionsDefaultGroupV1(),
        select: commonAPIDataSelector,
      }),
    listDefaultTypes: () =>
      queryOptions({
        queryKey: QUERY_KEYS.ROLE_TYPE_DEFAULT_PERMISSIONS(projectId),
        queryFn: () => api.getPermissionsDefaultTypeV1(),
        select: commonAPIDataSelector,
      }),
    listDefaultTicketCategories: () =>
      queryOptions({
        queryKey: QUERY_KEYS.REPAIR_CATEGORY_DEFAULT_PERMISSIONS(projectId),
        queryFn: () => api.getPermissionsDefaultRepairCategoryV1(),
        select: commonAPIDataSelector,
      }),
  };
};
